import useCommandCenter from '@/hooks/useCommandCenter.js';
import CommandCenterBoard from '@/components/command-center/CommandCenterBoard.jsx';
import { Button } from '@/components/ui/button.jsx';
import { RefreshCw } from 'lucide-react';

export default function CommandCenter() {
  const { data, error, loading, refresh } = useCommandCenter();

  if (loading && !data) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center text-sm text-text-muted">
        Loading pipeline…
      </div>
    );
  }

  if (error && !data) {
    return (
      <div className="mx-auto max-w-md p-4 text-center">
        <p className="rounded-card border border-accent/40 bg-accent-soft px-4 py-3 text-sm text-accent">
          Couldn't load the Command Center.
          <br />
          <span className="font-mono text-xs">{error.message || error.code || 'unknown'}</span>
        </p>
        <Button onClick={refresh} variant="outline" className="mt-4">
          <RefreshCw size={16} strokeWidth={1.5} />
          Retry
        </Button>
      </div>
    );
  }

  return <CommandCenterBoard data={data} />;
}
